"use client";
import React from "react";
import { Command } from "cmdk";
import Popover from "./popover";
import cn from "classnames";
import Icon from "./icon";
import ScrollArea from "./scroll-area";
import { PopoverContentProps } from "@radix-ui/react-popover";
import { BUTTON_VARIANCE } from "./button";

export interface ComboboxProps
  extends React.ComponentPropsWithoutRef<typeof Command>,
    PopoverContentProps {
  triggerPlaceholder: string;
  defaultValue?: string;
  options: Option[];
  height?: number;
  onSelectItem?: (value: string) => void;
}

function Combobox(props: ComboboxProps) {
  const [searchValue, setSearchValue] = React.useState<string>("all");
  const [value, setValue] = React.useState<string>(props.defaultValue || "");
  const [open, setOpen] = React.useState<boolean>(false);

  function customFilter(value: string, search: string) {
    if (!search) return 1;
    const index = value.toLowerCase().indexOf(search.toLowerCase());
    if (index === -1) return 0;
    return 1 - index / value.length;
  }
  

  function handleSelect(currentValue: string) {
    setValue(currentValue);
    props.onSelectItem?.(currentValue);
    setOpen(false);
  }
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Popover.Trigger
        className={cn(
          `${BUTTON_VARIANCE.base} ${BUTTON_VARIANCE.standard.base} ${BUTTON_VARIANCE.standard.size.md} ${BUTTON_VARIANCE.standard.color.filled.secondary} font-medium gap-4 outline-none group`,
          props.className
        )}
        aria-label={props.label}
        role="combobox"
        aria-expanded={open}
      >
        {/* {props.children} */}
        {value
          ? props.options.find((option) => option.value === value)?.label
          : props.triggerPlaceholder}
        <Icon
          name="caret-down"
          size="md"
          className="fill-primary-200 transition-transform duration-[50ms] ease-in-out group-hover:fill-dark group-data-[state=open]:-rotate-180"
        ></Icon>
      </Popover.Trigger>
      <Popover.Content sideOffset={8} align={props.align} className="fixed" side="bottom" collisionPadding={{top: 500}}>
        <Command {...props} value={searchValue} onValueChange={setSearchValue} filter={customFilter} label="Command Menu">
          <div className="py-3 px-4 flex items-center bg-surface border-b-[#E9EAEC] border-b rounded-tl-md rounded-tr-md">
            <Icon name="search-alternate" />
            <Command.Input
              placeholder="Search"
              className="px-2 outline-none w-full"
            />
          </div>
          <Command.List
            className="p-2 overflow-y-auto"
            style={{ height: `${props.height}rem` }}
          >
            <Command.Empty className="py-3 px-4 flex items-center">
              No results found.
            </Command.Empty>
            {/* {props.children} */}

            {props.options.map((option, i) => (
              <Command.Item
                key={i}
                aria-label={option.label as string}
                value={option.value}
                onSelect={handleSelect}
                className={`w-full text-body-sm-medium gap-2 flex items-center justify-between px-4 py-3.5 h-12 min-w-[10.5625rem] uppercase hover:cursor-pointer relative select-none data-[disabled=true]:pointer-events-none outline-none hover:fill-dark fill-primary-200 hover:bg-primary-500 data-[selected=true]:bg-primary-500 rounded-[0.325rem]`}
              >
                {option.label}
                {value === option.value && (
                  <Icon
                    name="checkmark"
                    size="md"
                    className="transition-none"
                  ></Icon>
                )}
              </Command.Item>
            ))}
          </Command.List>
        </Command>
      </Popover.Content>
    </Popover>
  );
}

// interface ComboboxTriggerProps extends PopoverTriggerProps {
//   label: string;
//   value?: string;
//   open: boolean;
//   placeholder?: string;
// }
// function Trigger(props: ComboboxTriggerProps) {
//   return (
//     <Popover.Trigger
//         className={cn(
//           `btn btn-md btn-secondary gap-4 outline-none group`,
//           props.className
//         )}
//         aria-label={props.label}
//         role="combobox"
//         aria-expanded={props.open}
//       >
//         {props.children}
//         {props.value
//           ? props.label
//           : props.placeholder}
//         <Icon
//           name="caret-down"
//           size="md"
//           className="fill-primary-200 transition-transform duration-200 ease-in-out group-hover:fill-light group-data-[state=open]:-rotate-180"
//         ></Icon>
//       </Popover.Trigger>
//   );
// }

// interface ComboboxContentProps {
//   popover: PopoverContentProps;
//   command: React.ComponentPropsWithoutRef<typeof Command>
// }
// function Content(props: ComboboxContentProps) {
//   return (
//     <Popover.Content sideOffset={8} {...props.popover}>
//     <Command {...props.command} value={props.command.value}>
//       <div className="py-3 px-4 flex items-center bg-surface border-b-[#E9EAEC] border-b rounded-tl-md rounded-tr-md">
//         <Icon name="search-alternate" />
//         <Command.Input
//           placeholder="Search"
//           className="px-2 outline-none w-full"
//         />
//       </div>
//       <Command.List className="p-2">
//         <Command.Empty className="py-3 px-4 flex items-center">No results found.</Command.Empty>
//         {props.command.children}
//       </Command.List>
//     </Command>
//   </Popover.Content>
//   );
// }
// Combobox.Trigger = Trigger;
// Combobox.Content = Content;
export default Combobox;
